// $(document).on('change', '.group_item, .select__select', function () {

// var addon_price = 0;
// $($(this).parents('.product__content-info').find('.addon_group')).each(function () {
//   if ($(this).parents('.addon_variants').is(':visible')) {
//     if ($(this).find('.group_item').is(":checked")) {
//       $(this).find('.quantity__button').removeAttr('disabled');
//       addon_price_with_qty = parseInt($(this).find('.variant_content .price').attr('data-price')) * parseInt($(this).find('[name="addon_quantity"]').val());
//       addon_price = parseInt(addon_price) + addon_price_with_qty;
//     } else {
//       $(this).find('.quantity__button').attr('disabled', true);
//     }
//   }
// });
// $('.addon_group_product .main_label .price.amount').text('$' + addon_price);
// });

document.addEventListener('change', function (event) {
  if (event.target.matches('.group_item, .select__select')) {
    let addon_price = 0;
    const productContentInfo = event.target.closest('.product__content-info');
    const addonGroups = productContentInfo.querySelectorAll('.addon_group');
    
    addonGroups.forEach(function (addonGroup) {
      const addonVariants = addonGroup.closest('.addon_variants');
      
      if (addonVariants && addonVariants.offsetParent !== null) {  // Check if visible
        const groupItem = addonGroup.querySelector('.group_item');
        
        if (groupItem.checked) {
          const quantityButton = addonGroup.querySelector('.quantity__button');
          quantityButton.removeAttribute('disabled');
          
          const priceElement = addonGroup.querySelector('.variant_content .price');
          const price = parseInt(priceElement.getAttribute('data-price'));
          const quantity = parseInt(addonGroup.querySelector('[name="addon_quantity"]').value);
          
          addon_price += price * quantity;
        } else {
          const quantityButton = addonGroup.querySelector('.quantity__button');
          quantityButton.setAttribute('disabled', true);
        }
      }
    });
    
    const priceLabel = document.querySelector('.addon_group_product .main_label .price.amount');
    if (priceLabel) {
      priceLabel.textContent = '$' + addon_price;
    }
  }
});
